/**
 * Converts a value to string.
 */
export function toString(val: any) {
  return val !== null && val !== undefined ? val.toString() : null;
}
